import React, { useState } from "react";
import styles from "./CardImage.module.css";
import { PropTypes } from "./CardPropsType";
import useDeviceSize from "./useDeviceSize";

const CardImageRatio: React.FC<PropTypes> = ({
  useWindow = true,
  useHeight = true,
  maxWidth = 0,
  bgImage,
  ratioDevide = 0,
  emptyCard = false,
  classes = ""
}) => {
  console.log("🚀 ~ file: CardImageRatio.tsx:15 ~ bgImage:", bgImage);
  const [width, height] = useDeviceSize();
  console.log("🚀 ~ file: CardImageRatio.tsx:17 ~ height:", height);
  const [imageLoaded, setImageLoaded] = useState(false);

  let widthValue: any = width > 400 ? width / 2 : width;
  let heightValue: any = "100%";

  if (maxWidth > 0) {
    widthValue = maxWidth;
    heightValue = (maxWidth * 3) / ratioDevide;
  } else {
    widthValue = useWindow ? width : "100%";
    heightValue = useHeight ? height / 2 : "100%";
  }

  type cardSizePropsType = {
    width: any;
    height: any;
    display: string;
    flexDirection: any;
    overflow: string;
    borderRadius: string;
  };

  const cardSize: cardSizePropsType = {
    width: widthValue,
    height: heightValue,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: "0.75rem"
  };

  const logoSizeForDetailsPage: cardSizePropsType = {
    width: "70px",
    height: "70px",
    display: "flex",
    flexDirection: "column",
    overflow: "none",
    borderRadius: "0.75rem"
  };

  type emptyCardSizeType = {
    width?: any;
    height?: any;
    display?: string;
    flexDirection?: any;
    overflow?: string;
    borderRadius?: string;
    backgroundSize?: string;
    backgroundColor?: string;
  };
  const emptyCardSize: emptyCardSizeType = cardSize;
  if (emptyCard) {
    emptyCardSize.backgroundSize = "cover";
    emptyCardSize.backgroundColor = "#d2d6da";
  }

  console.log(bgImage, "this is bgImage");
  return (
    <div className={`rounded overflow-hidden ${styles[classes]}`}>
      {!emptyCard && (
        <div className="rounded overflow-hidden" style={logoSizeForDetailsPage}>
          {bgImage && (
            <img
              loading="lazy"
              className=""
              src={bgImage}
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                backgroundColor: "#fffff",
                color: "rgb(46, 50, 56)",
                border: "1px solid #fffff"
              }}
              alt="backgroundImage"
              onLoad={() => setImageLoaded(true)}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CardImageRatio;
